import { css, SerializedStyles } from '@emotion/core';

import { Theme, normalText } from 'features/Theme';

export default {
  headingContainer: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  formFields: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  errorText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(1)}px;
    color: ${theme.mui.palette.error.main};
  `,
  bodyText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    margin-top: ${theme.mui.spacing(3)}px;
  `,
};
